/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Anupam's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Anupam Mohanty Portfolio",
    type: "website",
    url: "#",
  },
};

//Home Page
const greeting = {
  title: "Anupam Mohanty",
  logo_name: "Anupam Mohanty",
  nickname: "Jewel",
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/17FIKEsipQZWjiiN2LFNNyU46t97YC6Av/view?usp=share_link ",
  portfolio_repository: "https://github.com/anupam073",
  githubProfile: "https://github.com/anupam073",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/anupam073",
  // linkedin: "https://www.linkedin.com/in/anupam-mohanty-341228204",
  // gmail: "anupam.2003.mohanty@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://m.facebook.com/anupam.mohanty.1232",
  // twitter: "https://mobile.twitter.com/anupam_73",
  // instagram: "https://www.instagram.com/____j.e.w.e.l____/"

  {
    name: "Github",
    link: "https://github.com/anupam073",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/anupam-mohanty-341228204",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },

  {
    name: "Gmail",
    link: "mailto:anupam.2003.mohanty@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://mobile.twitter.com/anupam_73",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://m.facebook.com/anupam.mohanty.1232",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Whatsapp",
    link: "https://wa.me/qr/U4UZTNM2ZRDQK1",
    fontAwesomeIcon: "fa-whatsapp", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#00FF00", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/____j.e.w.e.l____/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Snapchat",
    link: "https://www.snapchat.com/add/anupammohan2021?share_id=oaTTnr5VHiM&locale=en-US",
    fontAwesomeIcon: "fa-snapchat", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#ffdf00", // Reference https://simpleicons.org/?q=instagram
  },
  
];

const skills = {
  data: [
    {
      title: "AI & ML",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with some Machine learning projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
       
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end.",
        "⚡ Creating application backend in Node, Express & Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
       
        
        {
          skillName: "AngularJs",
          fontAwesomeClassname: "vscode-icons:file-type-angular",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "ExpressJs",
          fontAwesomeClassname: "logos:express",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Jquery",
          fontAwesomeClassname: "logos:jquery",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "logos:php",
          style: {
            color: "#2C8EBB",
          },
        },
     
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
       
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Mysql",
          fontAwesomeClassname: "logos:mysql",
          style: {
            color: "#1488C6",
          },
        },
        // {
        //   skillName: "Kubernetes",
        //   fontAwesomeClassname: "simple-icons:kubernetes",
        //   style: {
        //     color: "#326CE5",
        //   },
        // },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
      
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Canva",
          fontAwesomeClassname: "cib:canva",
          style: {
            color: "#ADD8E6",
          },
        },
        // {
        //   skillName: "Inkscape",
        //   fontAwesomeClassname: "simple-icons:inkscape",
        //   style: {
        //     color: "#000000",
        //   },
        // },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/anupammohanty657",
    },
    {
      siteName: "Leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#7B3F00",
      },
      profileLink: "https://leetcode.com/anupam_mohanty/",
    },
    {
      siteName: "Geeksforgeeks",
      iconifyClassname: "simple-icons:geeksforgeeks",
      style: {
        color: "#006400",
      },
      profileLink: "",
    },
  
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "GIET University, Gunupur, Odisha-765022",
      subtitle: "B.Tech. in Computer science Engineering",
      logo_path: "giet.png",
      alt_name: "GIETU, Gunupur",
      duration: "2020 - Present",
      descriptions: [
        "⚡ I have studied basic CS subjects like DS, Algorithms, DBMS, OS, COA, AI, FLA etc.",
        "⚡ Apart from this, I have done courses on AI, Machine Learning, Robotics, Cloud Computing and Full Stack Development.",
      ],
      website_link: "http://giet.edu",
    },
    {
      title: "ASD Junior College, Tirtol, Odisha-754137",
      subtitle: "12th Science-CHSE",
      logo_path: "as.png",
      alt_name: "Tirtol, Jagatsinghpur",
      duration: "2018 - 2020",
      descriptions: [
        "⚡ I have studied basic Science subjects like physics, Chemistry, Geology, Mathematics, English and MIL-Odia",
        
      ],
      website_link: "https://www.indcareer.com/orissa/jagatsinghpur/adikavi-sarala-das-college-tirtol",
    },
    {
      title: "MS Academy, Tirtol, Odisha-754137",
      subtitle: "Schooling & 10th-BSE",
      logo_path: "my school.png",
      alt_name: "Tirtol, Jagatsinghpur",
      duration: "2015 - 2018",
      descriptions: [
        // "⚡ I have studied basic CS subjects like DS, Algorithms, DBMS, OS, COA, CN, AI, FLA etc.",
        // "⚡ Apart from this, I have done courses on Deep Learning, Machine Learning, Robotics, Cloud Computing and Full Stack Development.",
      ],
      website_link: "https://schools.org.in/jagatsinghpur/21110823501/mani-charan-sarala-academy-tirtol.html",
    },

  ],
};

const certifications = {
  certifications: [

    {
      title: "DevOps on AWS",
      subtitle: "DevOps on AWS: Code, Build, and Test",
      logo_path: "coursera.png",
      certificate_link:
        "#/education",
      alt_name: "",
      color_code: "#FFFFFF",
    },
    {
      title: "AWS Basics",
      subtitle: "AWS Cloud Technical Essentials",
      logo_path: "coursera.png",
      certificate_link:
        "#/education",
      alt_name: "",
      color_code: "#FFFFFF",
    },
   
    {
      title: "Cloud Computiing",
      subtitle: "",
      logo_path: "nptel.png",
      certificate_link:
        "#/education",
      alt_name: "",
      color_code: "#FFFFFF",
    },
    {
      title: "React js",
      subtitle: "Developing Front-End Apps with React",
      logo_path: "coursera.png",
      certificate_link:
        "#/education",
      alt_name: "",
      color_code: "#FFFFFF",
    },
    {
      title: "MEAN Stack",
      subtitle: "Full stack Development with MongoDB, Express, Angular, and Node.js",
      logo_path: "mclpl.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1eMMngxtUqGq1wnxj6yZi8KyNaTXarlQf/view?usp=share_link",
      alt_name: "",
      color_code: "#FFFFFF",
    },
    
     {
      title: "PHP & My Sql",
      subtitle: "PHP & My Sql Training",
      logo_path: "index1.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1FVyzSghdcWhX0fUxOh6SpSoiTccdfHve/view?usp=drivesdk",
      alt_name: "",
      color_code: "#FFFFFF",
    },
    {
      title: "Python",
      subtitle: "Python for Everybody",
      logo_path: "coursera.png",
      certificate_link:
        "https://drive.google.com/file/d/1FTY4FacN36n_9_IZ5xC2ttkGhmVtmkK3/view?usp=drivesdk",
      alt_name: "",
      color_code: "#FFFFFF",
    },
    {
      title: "C Programming",
      subtitle: "Training on C Programming",
      logo_path: "index1.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1FVHHW1C9pLqhQD-skatEAls-N3wtU2to/view?usp=drivesdk",
      alt_name: "",
      color_code: "#FFFFFF",
    },
   
    {
      title: "Basic Web development",
      subtitle: "HTML, CSS, JS for web developers",
      logo_path: "coursera.png",
      certificate_link:
        "https://drive.google.com/file/d/1hjws1H4EFCCarq1jJVnSDac4gf17mMCi/view?usp=drivesdk",
      alt_name: "",
      color_code: "#FFFFFF",
    },
    {
      title: "PHP",
      subtitle: "PHP For Web development",
      logo_path: "mclpl.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1ukb791vhts3K_DP2bN2CYQ5HNkoCZWOk/view?usp=drivesdk",
      alt_name: "",
      color_code: "#FFFFFF",
    },
    {
      title: "Oops!!",
      subtitle: "something went wrong",
      logo_path: "404.png",
      certificate_link:
        "",
      alt_name: "",
      color_code: "#FFFFFF",
    },
   
    
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I love organising events and that is why I am also involved with many opensource communities as a representative.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
       
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Data Analytics Intern",
          company: "Lagozon Edutech Pvt. Ltd.",
          company_url: "https://www.lagozon.com/",
          logo_path: "lagazon edutech.jpeg",
          duration: "May 2019 - Sept 2019",
          location: "Remote/WFH",
          description:
            "During my internship,i learned how to Identify, analyze, and interpret trends or patterns in complex data sets using statistical techniques and provide ongoing reports and dashboards using Microsoft PowerBI and Microsoft Excel Software.I gained some knowlege about Sql, python, R language and enable a business to take raw data,uncover patterns to extract valuable insights and visualize them. ",
          color: "#ee3c26",
        },
    
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Google Local Guide",
          company: "Google Map",
          company_url: "https://maps.google.com/localguides/",
          logo_path: "local guide.png",
          duration: "Present",
          location: "Work From Home",
          description:
            "Day-to-day responsibilities of helping local businesses to spread their business to the world. Helping users by writing reviews about different locations and spaces such as shops, malls, etc.",
          color: "#181717",
        },
        {
          title: "N.S.S Volunteer",
          company: "Nationl Service Scheme",
          company_url: "https://nss.gov.in/",
          logo_path: "nss.png",
          duration: "Present",
          location: "GIETU, Gunupur",
          description:
            "To understand the community work, need and problems of the community, involve in problem solving process &  gain skills in mobilising community participation",
          color: "#181717",
        },
      
        {
          title: "SARS Club (Technical & Support Team) Leader",
          company: "Student association of Robotic Science, GIETU",
          company_url: "https://get.edu",
          logo_path: "sars.png",
          duration: "Present",
          location: "GIETU, Gunupur",
          description:
            "Gathering of students who are interested in learning about and working with robots.At robotics competitions, teams of students must design and build a robot that can compete against opponents in a series of specific challenges.",
          color: "#181717",
        },
        {
          title: "Android & IOT club Member",
          company: "Android & IOT Club, CSE, GIETU",
          company_url: "https://get.edu",
          logo_path: "iot.png",
          duration: "Present",
          location: "GIETU, Gunupur",
          description:
            "The club Is mainly focusing on mastering the skills in students by having various hands-on sessions and some projects,Make students skilful in the devices Arduino, Raspberry Pi, Automation sensors, Actuators etc.Hands on workshops in the institute for skill development and experience.",
          color: "#181717",
        },
        {
          title: "NCC Cadet",
          company: " National Cadet Corps-1st odisha battalion, Cuttack",
          company_url: "https://indiancc.nic.in/",
          logo_path: "ncc.jpeg",
          duration: "2016-2018",
          location: "MS Academy,Tirtol",
          description:
            "it is Provide a Suitable Environment to Motivate and Take Up a Career in the Armed Forces. It Develop Character, Comradeship, Discipline, Leadership, Secular Outlook, Spirit of Adventure, and Ideals of Selfless Service amongst the Youth of the Country.",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety  technology tools. My best experience is to ML projects and deploy them to web applications.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "*********",
      name: "Personality Prediction using ML",
      createdAt: "Publishing soon....",
      description: "  The availability of a high dimensional data has paved the way for increasing marketing campaigns effectiveness by targeting specific groups of people. Such personality-basedcommunications are highly effective in increasing the recognition and attractiveness of products and services. That is developed a system for personality prediction using Big five personality traits in this project. ",
      url: "#",
    }
    
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_ashutosh.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you according to my knowledge.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "#",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Tirtol, Tirtol, SH-12, OD-21, Jgatsinghpur  Odisha-754137, India",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/Balakrishna+Bhawan/@20.3070646,86.3410743,17z/data=!3m1!4b1!4m5!3m4!1s0x3a1bd3e709beb459:0x3363ac8e3490e96d!8m2!3d20.3070596!4d86.3436492",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 7847088824",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
